import { http } from "./http";
import {
  AdminAuthResponse,
  AdminBootstrapStatus,
  AdminFirebaseAuthResponse,
  AdminInvite,
  AdminInvitePreview,
  AdminRole,
  AdminUser,
} from "../types/adminAuth";

type AdminUsersResponse = { items: AdminUser[] };
type AdminUserResponse = { user: AdminUser };
type AdminInvitesResponse = { items: AdminInvite[] };
type AdminInviteResponse = { invite: AdminInvite };
type AdminInvitePreviewResponse = { invite: AdminInvitePreview };

export const AdminAuthAPI = {
  async bootstrapStatus() {
    const res = await http.get<AdminBootstrapStatus>("/admin/auth/bootstrap-status");
    return res.data;
  },

  async bootstrap(payload: {
    fullName: string;
    email: string;
    password: string;
  }) {
    const res = await http.post<AdminAuthResponse>("/admin/auth/bootstrap", payload);
    return res.data;
  },

  async login(payload: { email: string; password: string }) {
    const res = await http.post<AdminAuthResponse>("/admin/auth/login", payload);
    return res.data;
  },

  async previewInvite(token: string) {
    const res = await http.get<AdminInvitePreviewResponse>(
      `/admin/auth/invite-preview?token=${encodeURIComponent(token)}`
    );
    return res.data;
  },

  async acceptInvite(payload: {
    token: string;
    fullName: string;
    password: string;
  }) {
    const res = await http.post<{ ok: boolean }>("/admin/auth/accept-invite", payload);
    return res.data;
  },

  async me() {
    const res = await http.get<AdminUserResponse>("/admin/auth/me");
    return res.data;
  },

  async firebaseToken() {
    const res = await http.get<AdminFirebaseAuthResponse>(
      "/admin/auth/firebase-token"
    );
    return res.data;
  },

  async changeMyPassword(payload: {
    currentPassword: string;
    newPassword: string;
  }) {
    const res = await http.post<{ ok: boolean }>(
      "/admin/auth/change-password",
      payload
    );
    return res.data;
  },

  async listUsers() {
    const res = await http.get<AdminUsersResponse>("/admin/users");
    return res.data;
  },

  async listInvites() {
    const res = await http.get<AdminInvitesResponse>("/admin/invites");
    return res.data;
  },

  async inviteUser(payload: {
    fullName: string;
    email: string;
    role: AdminRole;
  }) {
    const res = await http.post<AdminInviteResponse>("/admin/invites", payload);
    return res.data;
  },

  async revokeInvite(id: string) {
    const res = await http.post<AdminInviteResponse>(
      `/admin/invites/${encodeURIComponent(id)}/revoke`
    );
    return res.data;
  },

  async createUser(payload: {
    fullName: string;
    email: string;
    password: string;
    role: AdminRole;
  }) {
    const res = await http.post<AdminUserResponse>("/admin/users", payload);
    return res.data;
  },

  async updateUser(
    id: string,
    payload: Partial<{
      fullName: string;
      email: string;
      password: string;
      role: AdminRole;
      isActive: boolean;
    }>
  ) {
    const res = await http.patch<AdminUserResponse>(
      `/admin/users/${encodeURIComponent(id)}`,
      payload
    );
    return res.data;
  },
};
